import { decorate, observable, computed } from "mobx";

class ForgeVideoPost {
  videoTitle = "";
  videoDescription = "";
  videoId = "";
  videoUrl = "";
  thumbnailUrl = "";
  playIds = [];
  durationInSeconds = -1;
  playbackOptions = [];
  commonFields = {};

  constructor(clip, commonFields, playbackOptions) {
    this.videoTitle = clip.name;
    this.videoDescription = clip.name;
    this.videoId = clip.videoId;
    this.videoUrl = clip.url;
    this.thumbnailUrl = clip.thumbnailUri;
    this.playIds = clip.playIds;
    this.durationInSeconds = clip.durationInSeconds;
    this.playbackOptions = playbackOptions;
    this.commonFields = this.arrayToObject(commonFields);
  }

  /**
   *Turns array of [{name:gamePk,value:,...},{name:playId,value:...}] into
   * {gamePk:...,playId:...}
   */
  arrayToObject(commonFields) {
    return commonFields.reduce((current, next) => {
      current[next.name] = next.value;
      return current;
    }, {});
  }

  get formattedDuration() {
    const minutes = Math.floor(this.durationInSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(this.durationInSeconds % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  }
}

decorate(ForgeVideoPost, {
  videoTitle: observable,
  videoDescription: observable,
  videoId: observable,
  videoUrl: observable,
  thumbnailUrl: observable,
  playIds: observable,
  durationInSeconds: observable,
  playbackOptions: observable,
  commonFields: observable,
  formattedDuration: computed
});

export default ForgeVideoPost;



// WEBPACK FOOTER //
// ./src/models/ForgeVideoPost.js